import iphone from "../img/iphone.png";
import mouse from "../img/mouse.png";
import android from "../img/android.png";
import headphone from "../img/headphone.png";
import controller from "../img/controller.png";

export const productData= [
    {
        id: 1,
        image: iphone,
        name: "iPhone 13 Pro",
        desc: "Bionic Chip, Tripple AI cameras",
        price: 75000,
    },
    {
        id: 2,
        image: mouse,
        name: "Logitech G502 Hero",
        desc: "Laser Sensor with upto 6400dpi",
        price: 9999,
    },
    {
        id: 3,
        image: android,
        name: "Samsung Galaxy Fold",
        desc: "98MP camera, 512GB Storage",
        price: 85000,
    },
    {
        id: 4,
        image: headphone,
        name: "Sennheiser Headphones",
        desc: "45mm Dynamic Drivers",
        price: 8000,
    },
    {
        id: 5,
        image: controller,
        name: "PS5 DualShock Controller",
        desc: "Precision and Feel like never before",
        price: 7499,
    },
];